import { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { CollectionsHeader, CollectionsList } from "components/collections";
import { CreateNewCollectionPopup } from "components/UI/Popups/CreateNewCollectionPopup";
import { useUserName } from "hooks/useIsAuth";
import { useAccountQuery } from "queries";
import { IUser } from "services/types";

import "../common.scss";
import "./CollectionsPage.scss";
import { useSelector, useDispatch } from "react-redux";
import { IAppState } from "store/app-state";
import { setNewCollectionId } from "store/collections/collections-action";
import { FooterAds } from "components/ads/FooterAds";

const requireString = (value: string | undefined): string => {
  if (value === undefined) {
    throw new Error("user id not set");
  }

  return value;
};

export const CollectionsPage = () => {
  const ownerId = requireString(useParams().userId);
  const [owner, setOwner] = useState<IUser|undefined>(undefined);
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isCreateVisible, setCreateVisible] = useState<boolean>(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const newCollectionId = useSelector((state: IAppState) => state.collections.newCollectionId);

  const currentUserName = useUserName();

  // Request account info to validate that it exists.
  const userQuery = useAccountQuery({
    userName: ownerId,
  });

  useEffect(() => {
    if (userQuery.status === "success") {
      setOwner(userQuery.data);
    }
  }, [userQuery.status, userQuery.data]);

  useEffect(() => {
    setIsEditable(owner?.username === currentUserName);
  }, [owner, currentUserName]);

  useEffect(() => {
    if (owner) {
      document.title = `${owner.name ?? owner.username}'s Porn GIF Collections | RedGIFs`;
    }
  }, [owner]);

  useEffect(() => {
    if (newCollectionId) {
      navigate(`/users/${currentUserName}/collections/${newCollectionId}`);
    }

    return () => {
      dispatch(setNewCollectionId(null));
    };
    // eslint-disable-next-line
  }, [newCollectionId]);

  const handleCreateCollection = () => {
    setCreateVisible(true);
  };

  const handleCloseDialog = () => {
    setCreateVisible(false);
  };

  return (
    <Fragment>
      <div className="wide page collectionsPage">
        {userQuery.isLoading && <p className="loading">Loading...</p>}

        {owner && <CollectionsHeader
          user={owner}
          editable={isEditable}
          onCreate={handleCreateCollection}
        />}

        {isCreateVisible && <CreateNewCollectionPopup
          isOpen={true}
          togglePopup={handleCloseDialog}
        />}

        <CollectionsList
          userName={ownerId}
          showSaved={isEditable}
        />
      </div>

      <FooterAds/>
    </Fragment>
  );
};
